function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.tickets', {
			'abstract': true,
			'url': '/tickets',
			'template': '<div ui-view class="aside-content"></div>'
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/tickets/tickets.route.js
 **/